import React from "react";

const EmptyData = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full text-center px-4 py-20">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-16 w-16 text-gray-400 mb-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.75 9.75h4.5m-4.5 3h4.5m6 0a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 12.75v-9A2.25 2.25 0 016.75 1.5h10.5A2.25 2.25 0 0119.5 3.75v9zm-15 5.25h15m-12 2.25h9"
        />
      </svg>
      <h4 className="text-white text-lg font-medium mb-1">No data found</h4>
      <p className="text-sm text-gray-400">
        There’s nothing to show here right now.
      </p>
    </div>
  );
};

export default EmptyData;
